import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function PageLayout({ children, changeLang }) {
  return (
    <>
      <Header changeLang={changeLang} />
      <main>{children}</main>
      <Footer />
    </>
  );
}
